export const getPrice = (
  price: number,
  currencySymbol: string,
  isTypical = false
): string => {
  const priceDecimal =
    price % 1 === 0
      ? price?.toLocaleString("en-EN")
      : price?.toLocaleString("en-EN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

  const priceString =
    price >= 0
      ? `${currencySymbol}${isTypical ? price : priceDecimal}`
      : "Pending...";

  return priceString;
};
